import { featureItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 bg-secondary-100 text-secondary-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
            <i className="ri-star-line text-sm"></i>
            平台优势
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
            为什么选择我们
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            五大核心优势，为你打造最优质的吃瓜体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-2xl p-6 border border-background-200 text-center cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:shadow-lg group"
            >
              <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4 rounded-2xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="text-foreground-950 text-sm font-bold mb-2 font-heading">{item.title}</h3>
              <p className="text-foreground-500 text-xs leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}